import { SqlSnippetsSettingsSection } from '../../../sql-snippets/components/SqlSnippetsSettingsSection';

export function SnippetsSettingsTab() {
  return (
    <div className="space-y-4" data-testid="snippets-settings-tab">
      <SqlSnippetsSettingsSection />
    </div>
  );
}
